angular
  .module('pb.file')

  .directive('pbFileTable', function() {
    return {
      restrict: 'E',
      scope: {
        path: '<',
        editable: '<',
        filesNumber: '=',
        hideCreation: '<',
        type: '@'
      },
      templateUrl: 'modules/file/views/partials/pbFileTable.html',
      controller: [
        '$scope',
        '$element',
        '$controller',
        function($scope, $element, $controller) {
          $scope.enableListLoading = true;

          $controller('filesController', {
            $scope: $scope,
            $element: $element
          });

          $scope.$watch('files.length', function(newValue) {
            $scope.filesNumber = newValue;
          });
        }
      ]
    };
  });
